import React, { useState,useContext, useEffect } from "react";
import { SearchRoutes } from "./../../Routes";
import { NavLink } from "reactstrap";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import { ProductContext } from "../../store";
import Skeleton from "react-loading-skeleton";
import { isPlatformOverviewPath } from "../../utils/adminRoutes";

const SearchSidebar = () => {
	const [subMenuOpen, setSubMenuOpen] = useState([]);
	const [websitePlatform, setWebsitePlatform] = useState("");
	const location	= useLocation()
	const isPlatformOverview = isPlatformOverviewPath(location.pathname);
	const  {
		addPageOpen,
		userLoader,
		websiteLoader,
		websiteData,
		currentWebsiteId,
		userWebsitePlan,
		productTypes
	} = useContext(ProductContext);

	useEffect(() => {
		// Function to determine which parent menu should be open based on current URL
		const determineOpenSubmenu = () => {
			const currentPath = location.pathname;
			const openMenus = [];
			
			// Check each route to see if current path matches any submenu
			SearchRoutes.forEach(route => {
				if (route.subMenu && route.subMenu.length > 0) {
					// Check if any submenu path matches current URL
					const hasMatchingSubmenu = route.subMenu.some(subMenu => {
						const fullPath = route.layout + subMenu.path;
						return currentPath === fullPath || currentPath.startsWith(fullPath);
					});
					
					if (hasMatchingSubmenu) {
						openMenus.push(route.name);
					}
				}
			});
			
			setSubMenuOpen(openMenus);
		};
		
		determineOpenSubmenu();
	}, [location.pathname])

	useEffect(() => {
		if (userLoader || websiteLoader || !currentWebsiteId) {
			return;
		}
		setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType || "");
	}, [currentWebsiteId, userLoader, websiteLoader, websiteData])

	const handleTopMenu = (e, searchRoute) => {
		if( location.pathname && searchRoute.path && location.pathname !== searchRoute.layout + searchRoute.path ){
			return
		}
		if( !searchRoute.path ){
			e.preventDefault()
		}
		if( subMenuOpen.indexOf(searchRoute.name) > -1 ){
			setSubMenuOpen(subMenuOpen.filter(item => item !== searchRoute.name))
		}else{
			setSubMenuOpen([...subMenuOpen, searchRoute.name])
		}
	}

	if (isPlatformOverview) {
		return null;
	}

	return (
		<div className="innerSideBarContainer" style={{ display: addPageOpen ? 'none' : 'flex' }} >
			<header className="inner-header text-center align-items-center justify-content-start d-flex">
				{/* <svg viewBox="0 0 160 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stl-text-grey-800" height="16" style={{ marginLeft: "8px" }}>
					<circle cx="12" cy="9.6" fill="currentcolor" r="8.4" />
					<rect x="9" y="6.6" width="6" height="6" rx="3" fill="#fff"></rect>
					<path d="M12.9 19.05 16.35 18l1.8 5.1h-3.6l-1.65-4.05Z" fill="currentcolor" />
					<path d="M45.88 21c-1.2 0-2.24-.2-3.12-.6-.88-.4-1.56-.968-2.04-1.704-.464-.752-.704-1.632-.72-2.64h3c0 .72.256 1.288.768 1.704.528.4 1.24.6 2.136.6.864 0 1.536-.2 2.016-.6.496-.4.744-.952.744-1.656 0-.592-.176-1.104-.528-1.536-.336-.448-.824-.752-1.464-.912l-2.016-.552c-1.376-.352-2.44-.984-3.192-1.896-.736-.912-1.104-2.016-1.104-3.312 0-.992.224-1.856.672-2.592.448-.736 1.08-1.304 1.896-1.704.832-.4 1.808-.6 2.928-.6 1.696 0 3.04.44 4.032 1.32.992.864 1.496 2.032 1.512 3.504h-3c0-.688-.224-1.224-.672-1.608-.448-.4-1.08-.6-1.896-.6-.784 0-1.392.184-1.824.552-.432.368-.648.888-.648 1.56 0 .608.16 1.128.48 1.56.336.416.816.712 1.44.888l2.088.576c1.392.352 2.456.984 3.192 1.896.736.896 1.104 2.008 1.104 3.336 0 .992-.24 1.872-.72 2.64-.48.752-1.152 1.336-2.016 1.752-.864.416-1.88.624-3.048.624Zm16.455-.24V3.24h10.512v2.616h-7.56v4.56h6.72v2.592h-6.72v5.136h7.56v2.616H62.335Zm20.318 0L87.07 3.24h3.864l4.44 17.52h-3.072l-.96-4.248h-4.656l-.96 4.248h-3.072Zm4.584-6.696h3.552L89.733 9.36c-.176-.784-.328-1.488-.456-2.112a49.56 49.56 0 0 1-.264-1.392 49.56 49.56 0 0 1-.264 1.392 32.01 32.01 0 0 1-.456 2.088l-1.056 4.728Zm17.991 6.696V3.24h5.544c1.168 0 2.176.216 3.024.648.864.432 1.536 1.04 2.016 1.824.48.768.72 1.68.72 2.736 0 1.152-.296 2.168-.888 3.048a4.69 4.69 0 0 1-2.352 1.872l3.48 7.392h-3.36l-3.048-6.96h-2.136v6.96h-3Zm3-9.6h2.544c.848 0 1.512-.232 1.992-.696.48-.464.72-1.104.72-1.92 0-.832-.24-1.48-.72-1.944-.48-.48-1.144-.72-1.992-.72h-2.544v5.28ZM132.291 21c-1.12 0-2.104-.208-2.952-.624a4.798 4.798 0 0 1-1.944-1.8c-.448-.784-.672-1.704-.672-2.76V8.184c0-1.072.224-1.992.672-2.76a4.638 4.638 0 0 1 1.944-1.776c.848-.432 1.832-.648 2.952-.648 1.136 0 2.112.216 2.927.648a4.646 4.646 0 0 1 1.945 1.776c.464.768.695 1.688.695 2.76h-3.023c0-.832-.224-1.464-.672-1.896-.432-.432-1.056-.648-1.872-.648-.816 0-1.449.216-1.896.648-.448.432-.672 1.056-.672 1.872v7.656c0 .816.224 1.448.672 1.896.447.432 1.08.648 1.896.648.816 0 1.44-.216 1.872-.648.448-.448.672-1.08.672-1.896h3.023c0 1.04-.231 1.952-.695 2.736a4.756 4.756 0 0 1-1.945 1.824c-.815.416-1.791.624-2.927.624Zm16.142-.24V3.24h3v7.032h4.704V3.24h3v17.52h-3v-7.704h-4.704v7.704h-3Z" fill="currentcolor" />
				</svg> */}
				<svg viewBox="0 0 160 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stl-text-grey-800" height="18" style={{marginLeft: "8px"}}>
					<g transform="translate(0, 0)">
						<path d="M21 12V10C21 7.23858 18.7614 5 16 5H8C5.23858 5 3 7.23858 3 10C3 12.7614 5.23858 15 8 15H12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
						<path d="M20.1241 19.1185C20.6654 18.5758 21 17.827 21 17C21 15.3431 19.6569 14 18 14C16.3431 14 15 15.3431 15 17C15 18.6569 16.3431 20 18 20C18.8299 20 19.581 19.663 20.1241 19.1185ZM20.1241 19.1185L22 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
					</g>
					<g transform="translate(0, 0)">
						<path d="M45.88 21c-1.2 0-2.24-.2-3.12-.6-.88-.4-1.56-.968-2.04-1.704-.464-.752-.704-1.632-.72-2.64h3c0 .72.256 1.288.768 1.704.528.4 1.24.6 2.136.6.864 0 1.536-.2 2.016-.6.496-.4.744-.952.744-1.656 0-.592-.176-1.104-.528-1.536-.336-.448-.824-.752-1.464-.912l-2.016-.552c-1.376-.352-2.44-.984-3.192-1.896-.736-.912-1.104-2.016-1.104-3.312 0-.992.224-1.856.672-2.592.448-.736 1.08-1.304 1.896-1.704.832-.4 1.808-.6 2.928-.6 1.696 0 3.04.44 4.032 1.32.992.864 1.496 2.032 1.512 3.504h-3c0-.688-.224-1.224-.672-1.608-.448-.4-1.08-.6-1.896-.6-.784 0-1.392.184-1.824.552-.432.368-.648.888-.648 1.56 0 .608.16 1.128.48 1.56.336.416.816.712 1.44.888l2.088.576c1.392.352 2.456.984 3.192 1.896.736.896 1.104 2.008 1.104 3.336 0 .992-.24 1.872-.72 2.64-.48.752-1.152 1.336-2.016 1.752-.864.416-1.88.624-3.048.624Zm16.455-.24V3.24h10.512v2.616h-7.56v4.56h6.72v2.592h-6.72v5.136h7.56v2.616H62.335Zm20.318 0L87.07 3.24h3.864l4.44 17.52h-3.072l-.96-4.248h-4.656l-.96 4.248h-3.072Zm4.584-6.696h3.552L89.733 9.36c-.176-.784-.328-1.488-.456-2.112a49.56 49.56 0 0 1-.264-1.392 49.56 49.56 0 0 1-.264 1.392 32.01 32.01 0 0 1-.456 2.088l-1.056 4.728Zm17.991 6.696V3.24h5.544c1.168 0 2.176.216 3.024.648.864.432 1.536 1.04 2.016 1.824.48.768.72 1.68.72 2.736 0 1.152-.296 2.168-.888 3.048a4.69 4.69 0 0 1-2.352 1.872l3.48 7.392h-3.36l-3.048-6.96h-2.136v6.96h-3Zm3-9.6h2.544c.848 0 1.512-.232 1.992-.696.48-.464.72-1.104.72-1.92 0-.832-.24-1.48-.72-1.944-.48-.48-1.144-.72-1.992-.72h-2.544v5.28ZM132.291 21c-1.12 0-2.104-.208-2.952-.624a4.798 4.798 0 0 1-1.944-1.8c-.448-.784-.672-1.704-.672-2.76V8.184c0-1.072.224-1.992.672-2.76a4.638 4.638 0 0 1 1.944-1.776c.848-.432 1.832-.648 2.952-.648 1.136 0 2.112.216 2.927.648a4.646 4.646 0 0 1 1.945 1.776c.464.768.695 1.688.695 2.76h-3.023c0-.832-.224-1.464-.672-1.896-.432-.432-1.056-.648-1.872-.648-.816 0-1.449.216-1.896.648-.448.432-.672 1.056-.672 1.872v7.656c0 .816.224 1.448.672 1.896.447.432 1.08.648 1.896.648.816 0 1.44-.216 1.872-.648.448-.448.672-1.08.672-1.896h3.023c0 1.04-.231 1.952-.695 2.736a4.756 4.756 0 0 1-1.945 1.824c-.815.416-1.791.624-2.927.624Zm16.142-.24V3.24h3v7.032h4.704V3.24h3v17.52h-3v-7.704h-4.704v7.704h-3Z" fill="currentcolor"></path>
					</g>
					</svg>
			</header>
			{websitePlatform === "" && (userLoader || websiteLoader) ?
				<>
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
				</>
				:
				// Only show search sidebar if user has search product type
				<nav aria-label="Search Navigation">
					<ul className="searchNavigationList">
						{SearchRoutes.map((searchRoute, index) => {
							if (searchRoute.hideInSidebar) {
								return null;
							}
							return(
								<React.Fragment key={index}>									
									{((!searchRoute.accessPlans || ( searchRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => searchRoute.accessPlans.includes(plan.planId)) ) ) && ( !searchRoute.availablePlatforms || ( searchRoute.availablePlatforms && searchRoute.availablePlatforms.includes(websitePlatform) ) ) && ( !searchRoute.productType || ( searchRoute.productType && productTypes.includes(searchRoute.productType) ) ) ) && (
										<li key={index}>
											<NavLink
												to={searchRoute.path ? searchRoute.layout + searchRoute.path : "#"}
												tag={NavLinkRRD}
												className={`navItem ${searchRoute.itemClass ? searchRoute.itemClass : ""}`}
												activeClassName="active"
												onClick={(e) => handleTopMenu(e, searchRoute)}
											>
												<div className="d-flex align-items-center justify-content-between">
													<div className="iconStringWrap">
														<i className={`fas ${searchRoute.fontIcon} text-white`} style={{ fontSize: "14px", marginRight: "8px" }}></i>
														{searchRoute.name}
													</div>
													{searchRoute.subMenu && searchRoute.subMenu.length > 0 &&
														<i className={`fas ${subMenuOpen.indexOf(searchRoute.name) === -1 ? "fa-chevron-right" : "fa-chevron-down"}`} style={{ fontSize: "10px" }} />
													}
												</div>
											</NavLink>
											{subMenuOpen.indexOf(searchRoute.name) !== -1 && searchRoute.subMenu && searchRoute.subMenu.length > 0 &&
												<div id={"linkGroup"+(index + 1)} className="linkGroup">
													<ul>
														{searchRoute.subMenu.map((subMenu, index) => {
															if( subMenu.menuFlag && ( !subMenu.availablePlatforms || ( subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform) ) ) && ( !subMenu.allowedWesbiteId || ( subMenu.allowedWesbiteId && subMenu.allowedWesbiteId.includes(currentWebsiteId) ) ) ){
																return (
																	<li key={index}>
																		<NavLink
																			to={subMenu.layout + subMenu.path}
																			tag={NavLinkRRD}
																			className={`navItem ${subMenu.itemClass ? subMenu.itemClass : ""}`}
																			activeClassName="active"
																			onClick={(e) => e.stopPropagation()}
																		>
																			{subMenu.name}
																		</NavLink>
																	</li>
																)
															}
															return null
														})}
													</ul>
												</div>
											}
										</li>
									)}
								</React.Fragment>
							)
						})}
					</ul>
				</nav>
			}
		</div>
	);
}

export default SearchSidebar;
